<script setup>
import { useBlockSafe } from '@/composables/useBlockSafe';
import RedSpot from '@/components/RedSpot.vue';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  hasTitle,
  text,
  hasText,
  image,
  hasImage,
  redSpot,
  hasRedSpot,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      backgroundColor === 'black' ? 'white' : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <RedSpot
      v-if="hasRedSpot"
      :position-vertical="redSpot.vertical"
      :position-horizontal="redSpot.horizontal"
    />
    <div class="container">
      <div class="text-image-block">
        <div v-if="hasTitle || hasText" class="text-image-block__top">
          <h2
            v-if="hasTitle"
            class="mb-0 text-image-block__title h2"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="title"
          ></h2>
          <div
            v-if="hasText"
            class="text-image-block__text h2 body-1-regular"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            v-html="text"
          ></div>
        </div>
        <NuxtImg
          v-if="hasImage"
          :src="image?.src"
          :alt="image?.alt"
          :width="image?.width"
          :height="image?.height"
          class="text-image-block__image"
          data-aos="zoom-in"
          data-aos-easing="ease-out-quad"
          loading="lazy"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.text-image-block {
  display: flex;
  flex-direction: column;
  gap: 40px;
  @include media-breakpoint-up(sm) {
    gap: 64px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 64);
  }
  &__title {
    text-align: center;
    margin: 0;
  }
  &__top {
    display: flex;
    flex-direction: column;
    gap: 32px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      gap: 48px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 48);
    }
  }
  &__image {
    border-radius: 4px;
    height: auto;
    width: 100%;
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
    }
  }
  &__text {
    text-align: center;
    @include media-breakpoint-up(md) {
      margin: 0 auto;
      max-width: 49%;
    }
  }
}
</style>
